export default function reducer(state = {
    outlets: [],
    fetching: false,
    fetched: false,
    errors: {},
}, action) {
    switch (action.type) {
        case 'OUTLETS_CN_INIT': {
            return {outlets: [], fetching: false, fetched: false, errors: {}};
        }
        case 'GET_OUTLETS_CN_PENDING': {
            return {...state, fetching: true, fetched: false}
        }
        case 'GET_OUTLETS_CN_FULFILLED': {
            return {
                ...state,
                fetching: false,
                fetched: true,
                outlets: action.payLoad.data,
            }
        }
        case 'GET_OUTLETS_CN_REJECTED':
            return {
                ...state, errors: action.payLoad
            }
        default:
    }

    return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/customerNumberReducer.js